import { createFileRoute } from "@tanstack/react-router";
import React from "react";
import { useTranslation } from "react-i18next";
import { Strong, Text } from "src/components/base/text";
import HeadingLayout from "src/components/base/heading-layout";
import { ApiUser } from "src/api/api_user";

/**
 * The properties for {@link TailscaleAccessPlanned}
 */
export type TailscaleAccessPlannedProps = {};

/**
 * The error page for tailscale user authentication when the user access is planned
 */
export default function TailscaleAccessPlanned(props: TailscaleAccessPlannedProps) {
    const [t] = useTranslation("user-tailscale");

    const data = Route.useLoaderData();

    return (
        <HeadingLayout heading={t("heading.access-planned")}>
            <Text>
                {t("description.access-planned")}
                <Strong>{new Date(data.access_start).toLocaleString()}</Strong>
                {"."}
            </Text>
        </HeadingLayout>
    );
}

export const Route = createFileRoute("/_user/u/tailscale-login/access-planned")({
    component: TailscaleAccessPlanned,
    loader: async () => ApiUser.localUser.getAccessExpiration(),
});
